import { ComponentStyles, defaultComponentStyles } from './componentStyles'
import { spacing } from './spacing'

export const auroraComponentStyles: ComponentStyles = {
  ...defaultComponentStyles,
  integratedBenefitsExplorer: {
    showEmbeddedCenterOfExcellenceEntrypoint: false,
    showHeader: true,
    showMinimizedBannerDesign: false,
    showBenefitsAndCoverageSection: true,
  },
  integratedBenefitsEntryCard: {
    showBorder: false,
    paddingHorizontal: spacing['16px'],
    divider: {
      height: '1px',
    },
    shouldShowArrow: false,
    allowBackgroundColorOverride: false,
    showEmbeddedCenterOfExcellenceEntrypoint: false,
  },
  compactImageCard: {
    useBodyText: false,
    shouldShowChevron: false,
    borderRadius: spacing['24px'],
    showBorder: false,
  },
  navBar: {
    useSmallBackButton: false,
  },
  useFloatingCardsShadows: false,
}
